import React, { useState, useEffect } from 'react'
import Header from "../components/Header";
import Footer from "../components/Footer";
import { FaTrash } from "react-icons/fa";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import { useParams } from "react-router-dom";
import Loader from "../components/Loader";
import { toast } from "react-toastify";
export default function CartPage() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [cartData, setCartData] = useState([]);
    useEffect(() => {
        fetchCartData();
    }, []);
    const fetchCartData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "cart/" + localStorage.getItem("userID");
            const response = await makeRequest("get", url);
            if (response) {
                const cartId = response?.data?.rfId;
                try {
                    let url = webEndPoint + "cartItem/" + cartId;
                    const response = await makeRequest("get", url);
                    if (response) {
                        setCartData(response?.data);
                        setLoading(false);
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const updateQty = async (cartItemId, qty) => {
        if (qty < 1) return;
        try {
            let url = webEndPoint + "cartItem/update";
            // await makeRequest("put", url, {
            //     cart_item_id: cartItemId,
            //     quantity: qty
            // });
            setCartData(prev =>
                prev.map(item =>
                    item.rfId === cartItemId
                        ? { ...item, quantity: qty }
                        : item
                )
            );
        } catch (err) {
            console.error(err);
            toast.error("Failed to update quantity");
        }
    };
    const removeItem = async (cartItemId) => {
        try {
            // let url = webEndPoint + "cartItem/delete/" + cartItemId;
            // await makeRequest("delete", url);
            setCartData(prev =>
                prev.filter(item => item.rfId !== cartItemId)
            );
            toast.success("Item removed from cart");
        } catch (err) {
            console.error(err);
            toast.error("Failed to remove item");
        }
    };
    const subtotal = cartData.reduce(
        (acc, item) => acc + item.price * item.quantity,
        0
    );
    return (
        <div>
            <Loader loading={loading} />
            <Header />
            <div className="cart-container">
                <h2 style={{ width: "100%", textAlign: "center" }}>My Cart</h2>
                <div className="gradient-line"></div>
                {cartData?.length === 0 ? (
                    <p className="empty-msg">Your cart is empty!</p>
                ) : (
                    <>
                        <div className="cart-grid">
                            {cartData?.map((item) => (
                                <div key={item.id} className="cart-card">
                                    <img src={item.color_image_url} alt={item.product_name} />
                                    <div className="cart-info">
                                        <p className="product-name">{item.product_name}</p>
                                        <p className="product-price">₹{item.price}</p>
                                        <div className="cart-qty">
                                            <label className="product-price">Qty: </label>
                                            <input
                                                className="product-price"
                                                type="number"
                                                min="1"
                                                value={item.quantity}
                                                onChange={(e) => updateQty(item.rfId, parseInt(e.target.value))} />
                                        </div>
                                        <button className="remove-btn" onClick={() => removeItem(item.id)}>
                                            <FaTrash /> Remove
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="cart-summary">
                            <p>Subtotal: <strong>₹{subtotal.toFixed(2)}</strong></p>
                            <button className="checkout-btn">Proceed to Checkout</button>
                        </div>
                    </>
                )}
            </div>
            <Footer />
        </div>
    )
}